var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 12C11.1046 12 12.0001 11.1046 12.0001 10C12.0001 8.89543 11.1046 8 10.0001 8C8.8955 8 8.00007 8.89543 8.00007 10C8.00007 11.1046 8.8955 12 10.0001 12Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.457825 10C1.73208 5.94291 5.52238 3 10 3C14.4777 3 18.2679 5.94288 19.5422 9.99996C18.268 14.0571 14.4777 17 10 17C5.52238 17 1.7321 14.0571 0.457825 10ZM14.0001 10C14.0001 12.2091 12.2092 14 10.0001 14C7.79093 14 6.00007 12.2091 6.00007 10C6.00007 7.79086 7.79093 6 10.0001 6C12.2092 6 14.0001 7.79086 14.0001 10Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0001,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.42387dc0c87abd33c3635ceef0bf3a00.svg";
export { ForwardRef as ReactComponent };